/* Import Css Style */
import './styles/Card_Focus_2.css'
/* Import React */
/* Components imports */


export const Card_Focus_2 = (props) =>{

    return(
        <div class={"Card_Focus_2_Container" + (!props.lift ? ' upup' : ' downdown')}
         style={{color:props.textColor, borderColor:props.borderColor, background:props.wrapColor
        , transform: props.lift ? 'none': 'translate(0px, 120px)'
        }}

         onClick={() => {

             if (props.urlTo){
                 window.open(props.urlTo, '_blank', 'noopener,noreferrer');
             }
         }}
        >
            <p class="Card_Focus_2_Text">
                <div className="Card_Focus_2_index" style={{color: props.indexColor}}>{props.index} </div>
                {props.content}
            </p>
            <img src={props.img} alt={props.alt} class="Card_Image" />
        </div>
    )
}
